import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
  Table,
} from "reactstrap";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../components/Paginationv3";
// import Pagination from "./Pagination";
//useQuery
import { useQueries } from "react-query";
//componentes
import ModalNewFlight from "./ModalNewFlight";
import ModalAllImports from "./ModalAllImports";
import TableFlight from "./tableFlight";
import ModalLinksEmbeded from "./ModalLinksEmbeded";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
// location
import { useLocation } from "react-router-dom";
//service
import { getFlight, deleteAllFlights } from "../../../utils/services/flight";
import { getParticipantsLogistic } from "../../../utils/services/participants";
import useDebounce from "../../../utils/hooks/useDebounce";
import { createXlsx } from "./createXlsx";
import WaitExport from "../../../components/WaitExport";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../components/SearchFilters";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";

function Voo(props) {
  const location = useLocation();
  const idEvent = location.state.idEvent;
  const token = props.state.global_user_data.data.token;

  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewFlight, setModalNewFlight] = useState(false);
  const [modalLinksEmbeded, setModalLinksEmbeded] = useState(false);
  const [modalAllImports, setModalAllImports] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  const [voo, setVoo] = useState([]);
  //deletar voo
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [dynamic_title, setdynamic_title] = useState("");
  const [dynamic_description, setdynamic_description] = useState("");
  //editar voo
  const [editFlight, setEditFlight] = useState();
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  //state de participants
  // const [participants, setParticipants] = useState([]);
  const participants = useRef(null);
  const [countData, setCountData] = useState(1);
  // itens por pagina
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // collapse
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("login");

  const columnsFilter = [
    { name: "Participante", value: "login", type: "text" },
    { name: "Companhia", value: "company", type: "text" },
    { name: "Origem", value: "origin", type: "text" },
    { name: "Destino", value: "destination", type: "text" },
    { name: "Data Embarque", value: "boardingdate", type: "date" },
    { name: "Data Chegada", value: "arrivaldate", type: "date" },
  ];

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }
  const debouncedSearch = useDebounce(search, 300);
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }
  function toggleNewFlight() {
    setModalNewFlight(!modalNewFlight);
  }

  async function confirmDeleteAllFlights() {
    await deleteAllFlights({
      jwt: token,
      eventId: idEvent,
    }).then((response) => {
      setsuccess_dlg(true);
      setdynamic_title("Sucesso");
      setdynamic_description("Voos deletados com sucesso");
    });
  }

  const data = useQueries([
    {
      queryKey: ["getAllParticipants" + idEvent, 1],
      queryFn: async () => {
        const partForm = await getParticipantsLogistic({
          jwt: token,
          idEvent: idEvent,
          offset: 0,
          limit: 0,
          search: "",
        });

        participants.current = partForm?.data?.data;
      },
    },
    {
      queryKey: [
        "getAllVoo" + idEvent + currentIndex + itemsPerPage + debouncedSearch,
        2,
      ],
      notifyOnChangeProps: ["currentIndex"],
      queryFn: async () => {
        const vooData = await getFlight({
          jwt: token,
          idEvent: idEvent,
          offset: currentIndex > 0 ? currentIndex : 1,
          limit: itemsPerPage,
          search: treatmentSearch(),
          columnSearch: activeFilter,
        });

        setCountData(vooData.findOneFlightData.count);
        setVoo(vooData.findOneFlightData.data);
      },
    },
  ]);

  useEffect(() => {
    getFlight({
      jwt: token,
      idEvent: idEvent,
      offset: currentIndex > 0 ? currentIndex : 1,
      limit: itemsPerPage,
      search: debouncedSearch,
    }).then((vooData) => {
      setCountData(vooData.findOneFlightData.count);
      setVoo(vooData.findOneFlightData.data);
    });

    getParticipantsLogistic({
      jwt: token,
      idEvent: idEvent,
      offset: 0,
      limit: 0,
      search: "",
    }).then((partForm) => {
      participants.current = partForm?.data?.data;
    });
  }, []);

  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Voos"
          onConfirm={confirmDeleteAllFlights}
        />
      )}

      {modalNewFlight && (
        <ModalNewFlight
          isOpen={modalNewFlight}
          toggle={toggleNewFlight}
          idEvent={idEvent}
          data={() => {
            data[0].refetch();
            data[1].refetch();
          }}
          participants={participants?.current}
        />
      )}

      {modalLinksEmbeded && (
        <ModalLinksEmbeded
          isOpen={modalLinksEmbeded}
          toggle={() => setModalLinksEmbeded(false)}
          eventId={idEvent}
        />
      )}

      {modalAllImports && (
        <ModalAllImports
          isOpen={modalAllImports}
          toggle={() => setModalAllImports(false)}
          idEvent={idEvent}
          data={() => {
            data[0].refetch();
            data[1].refetch();
          }}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={dynamic_title}
          onConfirm={() => {
            data[0].refetch();
            data[1].refetch();
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <WaitExport
        isOpen={exportInProgress}
        name="Voos"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />

      <Card>
        <CardBody>
          <CardTitle>Voo</CardTitle>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
            }}
          >
            <Button
              color="success"
              className="btn-rounded waves-effect waves-light events-button-add"
              style={{ marginRight: 10 }}
              onClick={() => setModalLinksEmbeded(true)}
            >
              Links Para Embedar
            </Button>
          </div>

          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type={
                    activeFilter === "boardingdate" ||
                    activeFilter === "arrivaldate"
                      ? "date"
                      : "text"
                  }
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                {voo.length > 0 && (
                  <Row className="mobile-btns-top">
                    <div
                      onClick={() =>
                        createXlsx({
                          jwt: token,
                          idEvent: idEvent,
                          limit: 100,
                          countData,
                          setFinishExport,
                        }) > setExportInProgress(true)
                      }
                    >
                      Exportar Voo
                    </div>
                  </Row>
                )}
                <Row className="mobile-btns-top">
                  <div onClick={() => setModalAllImports(true)}>
                    Importar Voo
                  </div>
                </Row>

                <ActionButtonRounded
                  title="Adicionar Voo"
                  onClick={() => setModalNewFlight(true)}
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              {voo.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() =>
                    createXlsx({
                      jwt: token,
                      idEvent: idEvent,
                      limit: 100,
                      countData,
                      setFinishExport,
                    }) > setExportInProgress(true)
                  }
                >
                  Exportar Voo
                </Button>
              )}
              <ActionButtonRounded
                title="Importar Voo"
                onClick={() => setModalAllImports(true)}
                margin={"0 5px"}
              />

              <ActionButtonRounded
                title="Adicionar Voo"
                onClick={() => setModalNewFlight(true)}
              />
            </div>
          </div>

          {data[1].isFetching ? (
            <div className="table-responsive">
              <Table>
                <thead className="table-light">
                  <tr>
                    <th>Participante</th>
                    <th>Companhia</th>
                    <th>Origem</th>
                    <th>Destino</th>
                    <th>Data/hora embarque</th>
                    <th>Data/hora chegada</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <LoadingSkelentonTable lines={10} cols={7} />
                </tbody>
              </Table>
            </div>
          ) : (
            <TableFlight
              voo={voo}
              idEvent={idEvent}
              data={() => {
                data[0].refetch();
                data[1].refetch();
              }}
              participants={participants.current ? participants.current : []}
            />
          )}
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            voo?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {voo.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todos Voos"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
          />
        )}
        {/* 
      Fornecer os 8 parametros obrigatórios;
      ** data - a array contendo as informações da tabela
      ** search - o state do termo de pesquisa
      ** currentIndex - posição atual do index
      ** setCurrentIndex - função para atualizar a posição atual do index
      ** countData - quantidade total de itens
      ** maxItemPerPage - estado quantidade de de itens por página
      ** setMaxItemPerPage - função que troca o estado com a quantidade maxima de itens por página 
      ** maxPageButtonsToShow - quantidade de botões qua vão aparecer para a pessoa clicar, somente números impares
      ** 5 = vai de 1 até 5 / 7 vai de 1 até 7 
      */}
        <Pagination
          data={voo}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Voo);
